import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Table, Upload, Switch, Select, Button, Icon, message } from 'antd';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import './contacts.scss';
import config from '../../config';
import SsoApi from '../../api/SsoApi';
import { CONTACTS_GROUPS_RESOURCE_NAME, CONTACTS_RESOURCE_NAME } from '../../config/constants';
import { ApiError } from '../../utils/errors';
import { _callResource } from '../../context/_callResource';
import { importContactsColumns } from './columns/importContactsColumns';
import TEXTS from "../../locale/texts";

class ImportContact extends Component {
  state = {
    groups: [],
    chosenGroups: [],
    isLoading: false,
    isLoadingFile: false,
    inBlackList: false,
    isLoadingGroups: true,
    dataFromFile: null,

    createBulkContactsIsLoading: false,
    createBulkContactsError: null,

    contactsGroupsData: [],
    contactsGroupsDataIsLoading: true,
    contactsGroupsDataError: null,
  };

  callResource = _callResource.bind(this);
  columns = importContactsColumns.bind(this);

  uploadProps = {
    name: 'file',
    action: `${config.smsgwMessagingUrl}/api/extract/contacts`,
    beforeUpload: ({ size: bytes }) => {
      const KB = bytes / 1024;
      const MB = KB / 1024;
      console.log(
        'file size - KB:', KB,
        'file size - MB:', MB
      );
      if (MB > 5) {
        message.error(TEXTS.importFileTooBig[this.props.lang], 5);
        return Promise.reject();
      }
    },
    headers: {
      Authorization: `Bearer ${SsoApi.token}`,
      'X-Client-Bin': SsoApi.bin
    }
  };

  onBlackListChange = () => {
    this.setState(({ inBlackList }) => ({
      inBlackList: !inBlackList
    }));
  };

  toAllContacts = () => {
    this.props.history.push('/phonebook/contacts');
  };

  onChangeUpload = (info) => {
    const { chosenGroups } = this.state;
    const { lang } = this.props;
    const uploadingStatus = info.file.status;
    const response = info.file.response;
    if (uploadingStatus === 'uploading') {
      this.setState({ isLoadingFile: true });
    }
    if (uploadingStatus === 'done') {
      message.success(TEXTS.importFileIsLoaded[lang], 5);
      const newContacts = chosenGroups.length > 0
        ? response.contacts.map(item => ({ ...item,  groupIds: chosenGroups}))
        : response.contacts;
      this.setState((prevState) => ({
        dataFromFile: response ? [...(prevState.dataFromFile || []), ...newContacts] : (prevState.dataFromFile || []),
        isLoadingFile: false
      }));
    } else if (info.file.status === 'error') {
      message.error(TEXTS.importFileCouldNotLoad[lang]);
    }
  };

  componentDidMount = () => {
    const { promiseCancelToken } = this.props;
    this.setState({ selectedRows: [] });
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'get',
      promiseCancelToken,
      onSuccess: (response) => {
        const groups = response.data.items && response.data.items.map((item, i) => {
          return <Select.Option key={i} value={item.id}>{item.name}</Select.Option>;
        });
        this.setState({ groups });
      }
    });
  };

  saveContacts = async () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { dataFromFile, inBlackList } = this.state;
    const finalContacts = dataFromFile && dataFromFile.length > 0
      && dataFromFile.map((item) => ({
        ...item,
        inBlackList
      }));
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'createBulk',
      apiCallParams: finalContacts,
      promiseCancelToken,
      onSuccess: ({ data }) => {
        const addedMsisdns = data ? data['added_numbers'] : 'неизвестно';
        const duplicateMsisdns = data ? data['duplicated_numbers'] : 'неизвестно';
        addNotification(`${TEXTS.addedContactsCount[lang]}: ${addedMsisdns}, ${TEXTS.addedContactsDuplicatesCount[lang]}: ${duplicateMsisdns}`);
        this.toAllContacts();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.contactsWereNotAdded[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  handleChangeSelectGroup = (chosenGroups) => {
    const { dataFromFile } = this.state;
    this.setState({ chosenGroups });
    if (dataFromFile && dataFromFile.length > 0) {
      const newContacts = dataFromFile.map(item => ({ ...item,  groupIds: chosenGroups}));
      this.setState({
        dataFromFile: newContacts,
        isLoadingFile: false
      });
    }
  };

  render() {
    const { lang } = this.props;
    const {
      groups,
      inBlackList,
      isLoadingFile,
      dataFromFile,
      createBulkContactsIsLoading
    } = this.state;
    const columns = this.columns(lang);

    return (
      <ContentWrapper>
        <h4 className="form-row title text-pink text-uppercase mb-4">
          {TEXTS.btnImportContacts[lang]}
        </h4>
        <div className="form-row mb-4">
          <Button
            type="primary"
            style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 15}}
            loading={createBulkContactsIsLoading}
            disabled={createBulkContactsIsLoading || !dataFromFile}
            onClick={this.saveContacts}
          >
            {TEXTS.btnAddContacts[lang]}
          </Button>
          <Button
            style={{padding: '0 20px', height: 40, fontSize: 15}}
            onClick={this.toAllContacts}>
            {TEXTS.btnCancel[lang]}
          </Button>
        </div>
        <div className="form-row mb-4">
          <p>
            {TEXTS.importFileDisclaimer[lang]}
          </p>
          <Upload {...this.uploadProps} onChange={this.onChangeUpload}>
            <Button size="large">
              <Icon type="upload" style={{ position: 'relative', top: -4 }}/> {TEXTS.btnImportFile[lang]}
            </Button>
          </Upload>
        </div>
        <div className='form-row mb-4'>
          <Select
            mode="multiple"
            style={{ maxWidth: 500, width: '100%' }}
            size="large"
            placeholder={TEXTS.contactGroupsPlaceholder[lang]}
            defaultValue={[]}
            onChange={this.handleChangeSelectGroup}
          >
            {groups}
          </Select>
        </div>
        <div className="form-row mb-4">
          <label className="mr-2">{TEXTS.btnBlackListAdd[lang]}</label>
          <Switch onChange={this.onBlackListChange} checked={inBlackList}/>
        </div>
        {isLoadingFile && !dataFromFile
          ? <p>{TEXTS.fileIsBeingProcessed[lang]}</p>
          : (dataFromFile && dataFromFile.length > 0 && <Table dataSource={dataFromFile} columns={columns} />)}
      </ContentWrapper>
    );
  }
}

export default withRouter(ImportContact);
